<template>
  <div>
    <div class="search-list">
      <span class="search-label">国家/地区：</span>
      <div class="search-con">
        <a :class="{'search-active' : selectedResult.state_id == 0}"
           @click="tabHospitalIndex(0,'不限',1,'state_id')">不限</a>
        <a :class="{'search-active' : selectedResult.state_id == list.id}"
           v-for="(list,index) in countries"
           :key="list.id"
           @click="tabHospitalIndex(list.id,list.name,1,'state_id')">{{list.name}}</a>
      </div>
    </div>
    <div class="search-list"
         v-for="(list,index) in bigList"
         :key="list.id">
      <span class="search-label">{{list.name}}：</span>
      <div class="search-con">
        <a :class="{'search-active' : selectedResult['disease' + list.id] == 0}"
           @click="tabHospitalIndex(0,`disease${list.id}`,2,'disease_id')">不限</a>
        <a :class="{'search-active' : selectedResult[`disease${list.id}`].includes(serve.id)}"
           v-for="(serve,idx) in list.disease"
           @click="tabHospitalIndex(serve.id,`disease${list.id}`,2,'disease_id')">{{serve.name}}</a>
      </div>
    </div>
    <!--<div class="search-input">
      <label for="keyword">关键字：</label>
      <input type="text"
             v-model="keyword">
      <button class="search-btn"
              @click="searching">搜索</button>
    </div>-->
  </div>
</template>
<script>
import * as apis from "@/api/other"
export default {
  data () {
    return {
      bigList: [],
      keyword: '',
      countries: [],
      service: [],
      diseases: [],
      departments: [],
      selectedResult: {
        state_id: 0
      },
      params: {
        disease_id: [],
        state_id: 0,
        keyword: ''
      },
      pageType: 0

    }
  },
  components: {
    // Slide,
    // Radio
  },
  created () {
    this.pageType = this.$route.params.type
  },
  mounted () {
    this.getCountry();
    this.getOtherTypes();
    // this.getDisease();
    // this.getDepartment();

  },
  methods: {
    sendParams () {
      this.$emit("showSideMenu", flag)
    },
    // tabHospitalIndex (val, name, select, form_id) {
    //   console.log(select)
    //   //form_id  字段名
    //   if (select == 1) {    //单选
    //     this.selectedResult.state_id = val;
    //     this.params.state_id = val;
    //   } else {              //多选
    //     if (this.selectedResult[name].includes(val)) {
    //       let index = this.selectedResult[name].indexOf(val);
    //       this.selectedResult[name].splice(index, 1)
    //     } else {
    //       this.selectedResult[name].push(val)
    //     }
    //     // this.params[name] = this.selectedResult[name];
    //   }
    //   // console.log(this.selectedResult)
    //   this.params.disease_id = [];
    //   this.$forceUpdate();
    //   for (let key in this.selectedResult) {
    //     if (key == 'state_id') { continue; }
    //     this.params.disease_id.push(this.selectedResult[key].join(','));
    //   }
    //   console.log(this.params)
    //   this.$emit("searchResult", this.params);
    // },
    tabHospitalIndex (val, name, select, form_id, form_name) {
      //form_id  字段名
      if (select == 1) {    //单选
        this.selectedResult.state_id = val;
        this.params.state_id = val;
      } else {
        if (!this.selectedResult[name].length) {
          if (this.selectedResult[name].includes(val)) {
            let index = this.selectedResult[name].indexOf(val);
            this.selectedResult[name].splice(index, 1)
          } else {
            this.selectedResult[name].push(val)
          }
        } else {
          this.selectedResult[name][0] = val
        }             //多选
      }
      this.params.disease_id = [];
      this.$forceUpdate();
      for (let key in this.selectedResult) {
        if (key == 'state_id') { continue; }
        if (this.selectedResult[key] != 0) {
          this.params.disease_id.push(this.selectedResult[key].join(','));
        }
      }
      this.$emit("searchResult", this.params);
    },
    searching () {
      this.params.keyword = this.keyword;
      console.log(this.params)
      this.$emit("searchResult", this.params);
    },
    async getCountry () {
      try {
        let data = {};
        let res = await apis.getCountry(data);
        if (res.code == 200) {
          this.countries = res.data;
        }
      } catch (e) {
        window.console.log(e)
      }
    },
    async getOtherTypes () {
      try {
        let data = {};
        let res = await apis.getServiceTypes(data);
        if (res.code == 200) {
          this.bigList = res.data;
          res.data.forEach(item => {
            this.selectedResult[`disease${item.id}`] = [];
            if (this.pageType == 1) {
              this.selectedResult[`disease1`] = [52];
            }
          })
          for (let key in this.selectedResult) {
            if (key == 'state_id') { continue; }
            if (this.selectedResult[key] != 0) {
              this.params.disease_id.push(this.selectedResult[key].join(','));
            }
          }
          this.$emit("searchResult", this.params);
        }
      } catch (e) {
        window.console.log(e)
      }
    },
    // async getDisease(){
    //     try{
    //         let data = {};
    //         let res = await apis.getDisease(data);
    //         if(res.code == 200){
    //             this.diseases = res.data;
    //             this.diseases.forEach((item) => {
    //                 this.radioParams.disease_id.push(0);
    //                 this.radioParams.disease_tid.push(0);
    //             })
    //         }
    //     }catch(e){
    //         window.console.log(e)
    //     }
    // },
    // async getDepartment(){
    //     try{
    //         let data = {};
    //         let res = await apis.getDepartment(data);
    //         if(res.code == 200){
    //             this.departments = res.data;
    //         }
    //     }catch(e){
    //         window.console.log(e)
    //     }
    // }
  }
}
</script>
<style lang="less" scoped>
.search-input {
  margin-bottom: 15px;
  input {
    height: 24px;
  }
}
.search-selects {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  .ivu-select {
    width: 280px;
  }
  .ivu-icon-ios-arrow-down:before {
    content: '\F33D';
  }
  .ivu-select-large.ivu-select-single .ivu-select-selection {
    height: 45px;
  }
  .ivu-select-single {
    .ivu-select-selection {
      .ivu-select-selected-value {
        padding-left: 20px;
      }
    }
  }
}
.search-list {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  .search-label {
    display: inline-block;
    width: 80px;
    font-size: 14px;
    color: #333130;
    line-height: 24px;
  }

  .search-con {
    flex: 1;
    transition: all linear 0.5s;
    overflow: hidden;
    a {
      display: inline-block;
      height: 24px;
      color: #333130;
      font-size: 14px;
      line-height: 24px;
      border-radius: 4px;
      padding: 0 10px;
      margin-right: 10px;
      margin-bottom: 28px;
    }
    a.search-active {
      background: #ae1e10;
      color: #fff;
    }
  }
  .con1 {
    height: 52px;
    transition: height linear 0.5s;
  }
  .con2 {
    height: auto;
    transition: height linear 0.5s;
  }
}
.search-second {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  a.search-active {
    background: #ae1e10;
    color: #fff;
  }
  .search-sub-label {
    display: inline-block;
    min-width: 120px;
    height: 24px;
    color: #333130;
    font-size: 14px;
    padding: 0 10px;
    margin-right: 10px;
    box-sizing: border-box;
    border-right: 2px solid #8c8c8c;
  }
}
.search-slide {
  width: 80px;
  color: #ae1e10;
  font-size: 14px;
  line-height: 24px;
  cursor: pointer;
  padding: 0 10px;
}
.search-btn {
  width: 80px;
  background: #ae1e10;
  color: #fff;
  font-size: 14px;
  line-height: 24px;
  border: none;
}
</style>

